import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { IdResource } from "../../constants/IdResource";
import { componentWithProps } from "../generic/componentWithProps";
import { ResourceBar } from "../generic/resource-bar/ResourceBar";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
export var _MenuFarmManagement = function (_a) {
    var onClose = _a.onClose;
    var resourcesToDisplay = [IdResource.Money, IdResource.Gold];
    var footerComponent = componentWithProps({
        ComponentType: ResourceBar,
        resources: resourcesToDisplay,
    });
    return (React.createElement(MenuWrapper, { onClose: onClose, type: IdMenuBalancing.FarmManagement, footerRenderer: footerComponent, modalId: IdModal.FarmManagement }));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.FarmManagement)); },
}); };
export var MenuFarmManagement = connect(undefined, mapDispatch)(_MenuFarmManagement);



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/MenuFarmManagement.tsx
// module id = 2829
// module chunks = 3